
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...deploymentPath]]",
      function () {
        return require("private-next-pages/[[...deploymentPath]].tsx");
      }
    ]);
  